<template>
  <div>
    <p>Select any {{ objectName }}s associated with this contact.</p>
    <slot name="fields"></slot>
        <autocomplete :source="searchApi"
                      inputClass="form-control"
                      :placeholder="placeholder"
                      resultsValue="id"
                      :resultsDisplay="displayFunction"
                      clearAfterEntry
                      credentials="include"
                      :request-headers="requestHeaders"
                      @selected="select"></autocomplete>
      

      <b-table striped
                :items="value"
                :fields="fields"
                thead-class="hide-header"
                small
                show-empty
                :empty-text="emptyText"
                class="mt-2">
                
          <template v-slot:cell(cancel)="data">
            <div @click="remove(data.item)" class="m-2"><font-awesome-icon icon="times" /></div>
          </template>
          <template v-slot:cell(name)="data">
            <div v-html="display(data.item)" @click="remove(data.item)"></div>
          </template>
        </b-table>
      <slot name="buttons">

      </slot>

    
  </div>
</template>

<script>
import Autocomplete from "./autocomplete";
import * as _ from "lodash";

export default {
  data() {
    return {
      form: {
        items: []
      },
      fields: [{ key: "cancel" }, { key: "name" }],
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    };
  },

  props: {
    value: {
      type: Array
    },
    items: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    apiPath: {
      type: String,
      required: false,
      default: function() {
        return "";
      }
    },
    objectName: {
      type: String,
      required: false,
      default: function() {
        return "object";
      }
    },
    objectKey: {
      type: String,
      required: false,
      default: "id"
    },
    displayFunction: {
      type: Function,
      required: false
    },
    tableDisplayFunction: {
      type: Function,
      required: false
    },
    selectFunction: {
      type: Function,
      required: false
    }
  },

  computed: {
    searchApi: function() {
      return process.env.VUE_APP_BASE_URI + this.apiPath;
    },
    emptyText: function() {
      return "There are no " + this.objectName + "s selected.";
    },
    placeholder: function() {
      return "Search " + this.objectName + "s";
    }
  },

  components: {
    Autocomplete
  },
  methods: {
    display: function(item) {
      if (_.isFunction(this.tableDisplayFunction)) {
        return this.tableDisplayFunction(item);
      } else if (_.isFunction(this.displayFunction)) {
        return this.displayFunction(item);
      } else {
        return item.name;
      }
    },

    select: function(autoselectResponse) {
      if (_.isFunction(this.selectFunction)) {
        return this.selectFunction(autoselectResponse);
      }

      // check if award has already been added
      var found = _.find(this.value, selectedItem => {
        return (
          selectedItem[this.objectKey] ===
          autoselectResponse.selectedObject[this.objectKey]
        );
      });
      if (!found) {
        this.value.push(autoselectResponse.selectedObject);
      }
      this.$emit("input", this.value);
    },

    remove: function(item) {
      const items = _.reject(this.value, selectedItem => {
        return selectedItem[this.objectKey] === item[this.objectKey];
      });
      this.$emit("input", items);
    }
  }
  // watch: {
  //   items: function() {
  //     if (this.items) {
  //       this.form.items = _.clone(this.items);
  //       //this.$emit("update", this.form.items);
  //     }
  //   }
  // },
  // created() {
  //   if (this.items) {
  //     this.form.items = _.clone(this.items);
  //     //this.$emit("update", this.form.items);
  //   }
  // }
};
</script>

<style scoped>
.form-horizontal {
  font-size: 13px;
}

.award-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

.award-list {
  font-size: 16px;
}

.hide-header {
  display: none;
}
</style>
<style>
.hide-header {
  display: none;
}
</style>
